let webSocket: WebSocket | null = null;

interface KisConnectCallbacks {
  onError?: () => void;
  onClose?: () => void;
  onOpen?: () => void;
  onMessage?: (data: string) => void;
}

export const kisConnect = (
  endpoint: string,
  protocol: string,
  callbacks: KisConnectCallbacks = {}
): void => {
  const webSocketURL =
    protocol === 'wss' ? `wss://localhost:1517/${endpoint}` : `ws://localhost:1516/${endpoint}`;

  console.log(webSocketURL + ' Connecting...');

  try {
    webSocket = new WebSocket(webSocketURL);

    webSocket.onopen = () => {
      console.log('WebSocket OPEN');
      callbacks.onOpen?.();
    };

    webSocket.onclose = () => {
      console.log('WebSocket CLOSE');
      callbacks.onClose?.();
    };

    webSocket.onerror = () => {
      console.log('WebSocket ERROR');
      callbacks.onError?.();
    };

    webSocket.onmessage = (messageEvent) => {
      console.log('WebSocket MESSAGE: ', messageEvent.data);
      callbacks.onMessage?.(messageEvent.data);
    };
  } catch (exception) {
    console.error(exception);
    callbacks.onError?.();
  }
};

export const kisApproval = (message: string): void => {
  if (webSocket?.readyState === WebSocket.OPEN) {
    webSocket.send(message);
  } else {
    throw new Error('WebSocket is not open');
  }
};

export const kisDisconnect = (): void => {
  if (webSocket?.readyState === WebSocket.OPEN) {
    webSocket.close();
  }
};
